// extracted by mini-css-extract-plugin
export var black = "_2o-6";
export var brand = "_2o-1";
export var ddefault = "_2o-0";
export var error = "_2o-3";
export var gray = "_2o-2";
export var highContrast = "_2o-8";
export var outline = "_2o-7";
export var success = "_2o-5";
export var warning = "_2o-4";